import { HELP_MENU_CONTENT_TYPE } from '../help-menu/helpMenuEnums';
import { HelpContent } from '../help-menu/helpMenuInterfaces';

export const supportLinks = {
  gambleAware: 'https://www.begambleaware.org',
  gamcare: 'https://www.gamcare.org.uk',
  gamblersAnonymous: 'https://www.gamblersanonymous.org.uk',
  gamblingTherapy: 'https://www.gamblingtherapy.org',
};

export const content: HelpContent[] = [
  {
    type: HELP_MENU_CONTENT_TYPE.PARAGRAPH,
    contentId: 'help_support.help_organisations',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET_LINK,
    titleId: 'help_support.gamble_aware',
    beforeLinkContentId: 'help_support.gamble_aware_explanation',
    link: supportLinks.gambleAware,
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET_LINK,
    titleId: 'help_support.gam_care',
    beforeLinkContentId: 'help_support.gam_care_explanation',
    link: supportLinks.gamcare,
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET_LINK,
    titleId: 'help_support.gamblers_anonymous_uk',
    beforeLinkContentId: 'help_support.gamblers_anonymous_uk_explanation',
    link: supportLinks.gamblersAnonymous,
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET_LINK,
    titleId: 'help_support.gambling_therapy',
    beforeLinkContentId: 'help_support.gambling_therapy_uk_explanation',
    link: supportLinks.gamblingTherapy,
    afterLinkContentId: 'help_support.gambling_therapy_uk_second_explanation',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.PARAGRAPH,
    contentId: 'help_support.employee_training',
  },
];
